import MessageItem from "./message";
import styled from "styled-components";
import produce from "immer";
import {MessageType} from "./type";
import {useRef} from "react";

export default function Messages(props: {
    messages: Array<MessageType>,
    blobs?: any,
    setMessages?: (any) => void,
    paging: any,
    setPaging: (paging: any) => void;
    messagesRef: any;
    callInvited?: boolean;
}) {
    const {messages, paging, setPaging, setMessages} = props;
    const delayRef = useRef(0);

    const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
        // check scroll to top when flex-direction: column-reverse
        const div = event.currentTarget;
        // Check if scrolled to the top
        const isAtTop = Math.trunc(div.scrollTop + div.scrollHeight) <= (Math.trunc(div.clientHeight) + 1);
        if (isAtTop && !!paging && !paging?.loading && !paging?.isEnd && (Date.now() - delayRef.current) > 1000) {
            console.log("scroll end:", paging);
            setPaging(produce((draft: any) => {
                draft.loading = true;
                draft.page += 1;
                delayRef.current = Date.now();
            }));
        }
    }

    return (
        <Items className={`${props?.callInvited ? "call-invited" : ""}`} ref={props.messagesRef}
               onScroll={handleScroll}>
            {
                messages.map((item, index) => {
                    return (
                        <MessageItem
                            blobs={props?.blobs || {}}
                            key={item?.id || index.toString()}
                            message={item}
                            isSender={item.mode === "sent"}
                            onChange={(key, value) => {
                                setMessages(produce((draft: any) => {
                                    if (draft[index]) {
                                        draft[index][key] = value;
                                    }
                                }))
                            }}
                        />
                    )
                })
            }
            {
                paging?.loading ? (
                    <>
                        <MessageItem key={'loading-1'} message={{status: "loading", type: "text"}} isSender={true}/>
                        <MessageItem key={'loading-2'} message={{status: "loading", type: "text"}} isSender={false}/>
                        <MessageItem key={'loading-3'} message={{status: "loading", type: "text"}} isSender={true}/>
                    </>
                ) : null
            }
        </Items>
    )
}

const Items = styled.div`
    padding-left: 24px;
    padding-right: 24px;
    overflow-y: auto;
    padding-bottom: 48px;
    display: flex;
    flex-direction: column-reverse;
    flex: 1;
    height: 100%;
    transition: all 0.3s ease-in-out;

    &.call-invited {
        padding-bottom: 75px;
    }
`;